import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { RecoilRoot, useRecoilSnapshot } from 'recoil';
import './i18n';
import store from './store';
import App from './App';
import { RecoilDevTools as RecoilToolKit } from 'recoil-toolkit';
import { config } from './config';
import { CookiesProvider } from 'react-cookie';
import { createRoot } from 'react-dom/client';
import VConsole from 'vconsole';

new VConsole();

const root = createRoot(document.getElementById('root'));
let countSnapshot = 0
const DebugObserver = () => {
	const snapshot = useRecoilSnapshot();
	useEffect(
		() => {
			countSnapshot = countSnapshot + 1
			for (const node of snapshot.getNodes_UNSTABLE({
				isModified: true
			})) {
				// console.debug(node.key, snapshot.getLoadable(node));
				// console.debug(`Count ${countSnapshot} Atoms modified:`, node.key, snapshot.getLoadable(node).contents);
			}
		}, [snapshot]
	);

	return null;
};

root.render(
	<CookiesProvider defaultSetOptions={{ domain: '.prudential.co.th', path: '/' }}>
		<Provider store={store}>
			<RecoilRoot>
				{
					config.mode !== 'prd' && <>
						<DebugObserver />
						<RecoilToolKit forceSerialize={false} />
					</>
				}
				<App />
			</RecoilRoot>
		</Provider>
	</CookiesProvider>
);
